/**
 * Premium Product Info - Interactive Functionality
 * Handles carousel navigation, variant selection, delivery checker, and sticky ATC
 */

(function () {
  'use strict';

  function initCarousel(section) {
    const mainImage = section.querySelector('.premium-carousel__image');
    const mainContainer = section.querySelector('.premium-carousel__main');
    const thumbnails = section.querySelectorAll('.premium-carousel__thumb');

    if (!mainImage || !mainContainer || thumbnails.length === 0) return;

    let currentIndex = 0;
    let touchStartX = 0;
    let touchEndX = 0;
    let touchStartY = 0;
    let touchEndY = 0;
    const minSwipeDistance = 50;

    function changeToImage(index) {
      if (index < 0 || index >= thumbnails.length) return;

      const imageUrl = thumbnails[index].getAttribute('data-image-url');
      const imageSrcset = thumbnails[index].getAttribute('data-image-srcset');

      if (imageUrl && mainImage) {
        mainImage.style.opacity = '0';
        setTimeout(function () {
          mainImage.src = imageUrl;
          if (imageSrcset) mainImage.srcset = imageSrcset;

          const picture = mainImage.parentElement;
          if (picture && picture.tagName === 'PICTURE') {
            const source = picture.querySelector('source[type="image/webp"]');
            if (source && imageSrcset) source.srcset = imageSrcset;
          }

          mainImage.style.transition = 'opacity 0.3s ease';
          mainImage.style.opacity = '1';
        }, 150);
      }

      thumbnails.forEach(function (t, i) {
        t.classList.toggle('active', i === index);
      });

      currentIndex = index;
    }

    thumbnails.forEach(function (thumb, index) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        changeToImage(index);
      });
    });

    mainContainer.addEventListener('touchstart', function (e) {
      if (e.target.closest('.premium-carousel__zoom-btn')) return;
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    mainContainer.addEventListener('touchend', function (e) {
      if (e.target.closest('.premium-carousel__zoom-btn')) return;
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;

      const dx = touchEndX - touchStartX;
      const dy = Math.abs(touchEndY - touchStartY);

      if (Math.abs(dx) > dy && Math.abs(dx) > minSwipeDistance) {
        changeToImage(dx > 0
          ? (currentIndex === 0 ? thumbnails.length - 1 : currentIndex - 1)
          : (currentIndex === thumbnails.length - 1 ? 0 : currentIndex + 1));
      }
    }, { passive: true });

    mainContainer.addEventListener('click', function (e) {
      if (e.target.closest('.premium-carousel__zoom-btn')) return;
      if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;

      const rect = this.getBoundingClientRect();
      const pct = ((e.clientX - rect.left) / rect.width) * 100;

      if (pct < 40) {
        changeToImage(currentIndex === 0 ? thumbnails.length - 1 : currentIndex - 1);
      } else if (pct > 60) {
        changeToImage(currentIndex === thumbnails.length - 1 ? 0 : currentIndex + 1);
      }
    });

    mainContainer.addEventListener('mousemove', function (e) {
      if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;
      const pct = ((e.clientX - this.getBoundingClientRect().left) / this.getBoundingClientRect().width) * 100;
      this.style.cursor = pct < 40 ? 'w-resize' : pct > 60 ? 'e-resize' : 'pointer';
    });

    mainContainer.addEventListener('mouseleave', function () {
      this.style.cursor = 'pointer';
    });
  }

  function initLightbox(section) {
    const zoomBtn = section.querySelector('.premium-carousel__zoom-btn');
    const sectionId = section.getAttribute('data-section-id');
    const lightbox = document.querySelector('#premium-lightbox-' + sectionId);

    if (!lightbox || !zoomBtn) return;

    const lightboxImage = lightbox.querySelector('.premium-lightbox__image');
    const lightboxCounter = lightbox.querySelector('[id^="premium-lightbox-counter"]');
    const closeBtn = lightbox.querySelector('.premium-lightbox__close');
    const prevBtn = lightbox.querySelector('.premium-lightbox__nav--prev');
    const nextBtn = lightbox.querySelector('.premium-lightbox__nav--next');
    const overlay = lightbox.querySelector('.premium-lightbox__overlay');
    const thumbnails = section.querySelectorAll('.premium-carousel__thumb');

    if (thumbnails.length === 0) return;

    let currentLightboxIndex = 0;

    function updateLightboxImage() {
      const url = thumbnails[currentLightboxIndex].getAttribute('data-image-url');
      const alt = thumbnails[currentLightboxIndex].querySelector('img').alt;

      if (lightboxImage && url) {
        lightboxImage.style.opacity = '0';
        setTimeout(function () {
          lightboxImage.src = url;
          lightboxImage.alt = alt;
          lightboxImage.style.transition = 'opacity 0.3s ease';
          lightboxImage.style.opacity = '1';
        }, 150);
      }

      if (lightboxCounter) {
        lightboxCounter.textContent = (currentLightboxIndex + 1) + ' / ' + thumbnails.length;
      }
    }

    function openLightbox(index) {
      currentLightboxIndex = index || 0;
      updateLightboxImage();
      lightbox.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.remove('active');
      document.body.style.overflow = '';
    }

    zoomBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const active = section.querySelector('.premium-carousel__thumb.active');
      const idx = Array.from(thumbnails).indexOf(active);
      openLightbox(idx >= 0 ? idx : 0);
    });

    closeBtn.addEventListener('click', closeLightbox);
    overlay.addEventListener('click', closeLightbox);

    prevBtn.addEventListener('click', function () {
      currentLightboxIndex = currentLightboxIndex === 0 ? thumbnails.length - 1 : currentLightboxIndex - 1;
      updateLightboxImage();
    });

    nextBtn.addEventListener('click', function () {
      currentLightboxIndex = currentLightboxIndex === thumbnails.length - 1 ? 0 : currentLightboxIndex + 1;
      updateLightboxImage();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox.classList.contains('active')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') { currentLightboxIndex = currentLightboxIndex === 0 ? thumbnails.length - 1 : currentLightboxIndex - 1; updateLightboxImage(); }
      if (e.key === 'ArrowRight') { currentLightboxIndex = currentLightboxIndex === thumbnails.length - 1 ? 0 : currentLightboxIndex + 1; updateLightboxImage(); }
    });
  }

  function updateComparePrice(section, option) {
    const comparePrice = section.querySelector('.premium-price__compare');
    const offerBadge = section.querySelector('.premium-price__offer');
    const compare = option.getAttribute('data-variant-compare');
    const discount = parseInt(option.getAttribute('data-variant-discount'), 10) || 0;
    const hasDiscount = !!compare && discount > 0;

    if (comparePrice) {
      comparePrice.textContent = hasDiscount ? compare : '';
      comparePrice.style.display = hasDiscount ? '' : 'none';
    }
    if (offerBadge) {
      offerBadge.textContent = hasDiscount ? discount + '% OFF' : '';
      offerBadge.style.display = hasDiscount ? '' : 'none';
    }
  }

  function initVariants(section) {
    const variantOptions = section.querySelectorAll('.premium-variant__option');
    const variantIdInput = document.getElementById('premium-variant-id');
    const stickyVariantPrice = document.getElementById('selected-variant-price');
    const mainPrice = section.querySelector('.premium-price__current');
    const atcButton = section.querySelector('.premium-sticky-atc__button');

    if (variantOptions.length === 0) return;

    variantOptions.forEach(function (option) {
      option.addEventListener('click', function (e) {
        e.preventDefault();
        if (this.disabled) return;

        const group = this.closest('.premium-variant-group');
        group.querySelectorAll('.premium-variant__option').forEach(function (o) {
          o.classList.remove('active');
        });
        this.classList.add('active');

        const variantId = this.dataset.variantId;
        const variantPrice = this.dataset.variantPrice;

        if (variantIdInput && variantId) variantIdInput.value = variantId;
        if (mainPrice && variantPrice) mainPrice.textContent = variantPrice;
        if (stickyVariantPrice && variantPrice) stickyVariantPrice.textContent = variantPrice;

        updateComparePrice(section, this);

        if (atcButton) atcButton.disabled = false;

        const stickySelect = document.getElementById('premium-sticky-variant-select');
        if (stickySelect && variantId) stickySelect.value = variantId;
      }, true);
    });
  }

  function initInlineATC(section) {
    const sectionId = section.getAttribute('data-section-id');
    const btn = document.getElementById('premium-inline-atc-' + sectionId);
    if (!btn) return;

    const label = btn.querySelector('.premium-inline-atc__label');
    const variantOptions = section.querySelectorAll('.premium-variant__option');

    function setLabel(text) {
      if (label) label.textContent = text;
    }

    function currentVariantId() {
      const activeOpt = section.querySelector('.premium-variant__option.active');
      if (activeOpt && activeOpt.dataset.variantId) return activeOpt.dataset.variantId;
      const stickySelect = document.getElementById('premium-sticky-variant-select');
      if (stickySelect && stickySelect.value) return stickySelect.value;
      return btn.dataset.variantId || null;
    }

    // Keep the inline button in sync when a variant is picked.
    variantOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        if (this.disabled) return;
        btn.dataset.variantId = this.dataset.variantId;
        btn.disabled = false;
        btn.classList.remove('is-added');
        setLabel('Add to Cart');
      });
    });

    btn.addEventListener('click', async function () {
      const variantId = currentVariantId();
      if (!variantId) { alert('Please select a variant'); return; }

      btn.disabled = true;
      setLabel('Adding...');

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await res.json();

        let cart = { item_count: 0 };
        if (window.CartState) {
          cart = await window.CartState.update(true);
        } else {
          cart = await (await fetch('/cart.js')).json();
        }

        const bubble = document.querySelector('.header__icon--cart .cart-count-bubble');
        if (bubble) bubble.textContent = cart.item_count;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

        btn.classList.add('is-added');
        setLabel('Added ✓');
        setTimeout(function () {
          btn.classList.remove('is-added');
          setLabel('Add to Cart');
          btn.disabled = false;
        }, 1800);
      } catch (err) {
        console.error(err);
        setLabel('Error - Try Again');
        setTimeout(function () {
          setLabel('Add to Cart');
          btn.disabled = false;
        }, 2000);
      }
    });
  }

  function initShare(section) {
    const shareBtn = section.querySelector('.premium-info__share');
    if (!shareBtn) return;

    shareBtn.addEventListener('click', async function () {
      const shareData = {
        title: document.querySelector('.premium-info__title')?.textContent || 'Check out this product',
        text: document.querySelector('.premium-info__description')?.textContent || '',
        url: window.location.href
      };

      try {
        if (navigator.share) {
          await navigator.share(shareData);
        } else {
          await navigator.clipboard.writeText(window.location.href);
          const orig = shareBtn.innerHTML;
          shareBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>';
          shareBtn.style.background = '#123d07';
          shareBtn.style.color = '#fff';
          setTimeout(function () {
            shareBtn.innerHTML = orig;
            shareBtn.style.background = '';
            shareBtn.style.color = '';
          }, 2000);
        }
      } catch (err) {
        console.log('Share failed:', err);
      }
    });
  }

  function initDeliveryChecker(section) {
    const pincodeInput = document.getElementById('premium-pincode');
    const checkButton = document.getElementById('premium-check-delivery');
    const resultDiv = document.getElementById('premium-delivery-result');

    if (!pincodeInput || !checkButton || !resultDiv) return;

    function showResult(type, message) {
      resultDiv.className = 'premium-delivery__result ' + type;
      resultDiv.textContent = message;
    }

    function checkPincode(pincode) {
      const first = parseInt(pincode.charAt(0));
      return first >= 1 && first <= 8;
    }

    function getDeliveryDate() {
      const d = new Date();
      d.setDate(d.getDate() + 3);
      return d.toLocaleDateString('en-IN', { weekday: 'short', month: 'short', day: 'numeric' });
    }

    checkButton.addEventListener('click', function () {
      const pincode = pincodeInput.value.trim();
      if (!pincode || pincode.length !== 6 || !/^\d{6}$/.test(pincode)) {
        showResult('error', 'Please enter a valid 6-digit PIN code');
        return;
      }

      checkButton.textContent = 'Checking...';
      checkButton.disabled = true;

      setTimeout(function () {
        if (checkPincode(pincode)) {
          showResult('success', '✓ Delivery available! Estimated delivery by ' + getDeliveryDate());
        } else {
          showResult('error', '✗ Sorry, delivery not available for this PIN code');
        }
        checkButton.textContent = 'Check';
        checkButton.disabled = false;
      }, 1000);
    });

    pincodeInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') checkButton.click();
    });
  }

  function initStickyATC(section) {
    const stickyBar = section.querySelector('.premium-sticky-atc');
    const form = section.querySelector('.premium-sticky-atc__form');

    if (!stickyBar || !form) return;

    const CartState = window.CartState || {
      cache: null,
      listeners: new Set(),
      async fetch(force) {
        if (this.cache && !force) return this.cache;
        try {
          const res = await fetch('/cart.js');
          this.cache = await res.json();
          return this.cache;
        } catch (e) {
          return { items: [], item_count: 0 };
        }
      },
      async update(force) {
        const cart = await this.fetch(force);
        this.notify(cart);
        return cart;
      },
      notify(cart) { this.listeners.forEach(cb => cb(cart)); },
      subscribe(cb) { this.listeners.add(cb); return () => this.listeners.delete(cb); }
    };

    if (!window.CartState) window.CartState = CartState;

    function updateCartBubble(count) {
      const bubble = document.querySelector('.header__icon--cart .cart-count-bubble');
      if (bubble) {
        bubble.textContent = count;
      } else {
        const icon = document.querySelector('.header__icon--cart');
        if (icon) {
          const el = document.createElement('div');
          el.className = 'cart-count-bubble';
          el.textContent = count;
          icon.appendChild(el);
        }
      }
    }

    function showQuantitySelector(variantId, quantity) {
      const atcButton = form.querySelector('.premium-sticky-atc__button');
      if (!atcButton) return;

      let qtyEl = form.querySelector('.premium-sticky-quantity');
      if (qtyEl) {
        const inp = qtyEl.querySelector('.premium-quantity__input');
        if (inp) inp.value = quantity;
        return;
      }

      atcButton.style.display = 'none';
      qtyEl = document.createElement('div');
      qtyEl.className = 'premium-sticky-quantity';
      qtyEl.innerHTML = `
        <button class="premium-quantity__button premium-quantity__minus" type="button" aria-label="Decrease quantity">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
        </button>
        <input class="premium-quantity__input" type="number" min="0" value="${quantity}" aria-label="Quantity">
        <button class="premium-quantity__button premium-quantity__plus" type="button" aria-label="Increase quantity">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
        </button>
      `;
      atcButton.insertAdjacentElement('afterend', qtyEl);

      const minus = qtyEl.querySelector('.premium-quantity__minus');
      const plus = qtyEl.querySelector('.premium-quantity__plus');
      const input = qtyEl.querySelector('.premium-quantity__input');

      async function updateQty(newQty) {
        if (newQty < 0) newQty = 0;
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [variantId]: newQty } })
          });
          const cart = await res.json();
          input.value = newQty;
          CartState.cache = cart;
          CartState.notify(cart);
          updateCartBubble(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          if (newQty <= 0) {
            qtyEl.remove();
            atcButton.style.display = 'flex';
            atcButton.disabled = false;
            atcButton.innerHTML = '<span>Add to Cart</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
          }
        } catch (e) { console.error(e); }
      }

      minus.addEventListener('click', function () { updateQty(parseInt(input.value) - 1); });
      plus.addEventListener('click', function () { updateQty(parseInt(input.value) + 1); });
      input.addEventListener('change', function () { updateQty(parseInt(input.value) || 0); });
    }

    window.addEventListener('scroll', function () {
      stickyBar.style.transform = window.pageYOffset > 300 ? 'translateY(0)' : 'translateY(100%)';
    });

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      const variantId = formData.get('id');
      const atcButton = form.querySelector('.premium-sticky-atc__button');

      if (!variantId) { alert('Please select a variant'); return; }

      if (atcButton) { atcButton.disabled = true; atcButton.innerHTML = '<span>Adding...</span>'; }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        const item = await res.json();
        showQuantitySelector(item.variant_id, item.quantity);
        const cart = await CartState.update(true);
        updateCartBubble(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      } catch (err) {
        console.error(err);
        if (atcButton) {
          atcButton.disabled = false;
          atcButton.innerHTML = '<span>Add to Cart</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
        }
      }
    });

    const stickySelect = form.querySelector('select[name="id"]');
    const variantInput = form.querySelector('input[name="id"]');
    const currentVariantId = stickySelect ? stickySelect.value : (variantInput ? variantInput.value : null);

    if (currentVariantId) {
      CartState.fetch().then(function (cart) {
        const item = cart.items.find(function (i) { return i.variant_id == currentVariantId; });
        if (item) showQuantitySelector(item.variant_id, item.quantity);
        updateCartBubble(cart.item_count);
      });
    }

    CartState.subscribe(function (cart) {
      const vid = stickySelect ? stickySelect.value : (variantInput ? variantInput.value : null);
      if (!vid) return;
      const item = cart.items.find(function (i) { return i.variant_id == vid; });
      const qtyEl = form.querySelector('.premium-sticky-quantity');
      const atcButton = form.querySelector('.premium-sticky-atc__button');
      if (item) {
        if (!qtyEl) showQuantitySelector(item.variant_id, item.quantity);
      } else if (qtyEl) {
        qtyEl.remove();
        if (atcButton) { atcButton.style.display = 'flex'; atcButton.disabled = false; }
      }
      updateCartBubble(cart.item_count);
    });
  }

  function initStickyVariantSelect(section) {
    const stickySelect = document.getElementById('premium-sticky-variant-select');
    const mainPrice = section.querySelector('.premium-price__current');
    const stickyPrice = document.getElementById('selected-variant-price');
    const variantOptions = section.querySelectorAll('.premium-variant__option');

    if (!stickySelect) return;

    stickySelect.addEventListener('change', function () {
      const opt = this.options[this.selectedIndex];
      const variantId = this.value;
      const parts = opt.textContent.split(' - ');
      const price = parts[1] ? parts[1].split(' (')[0].trim() : '';

      if (stickyPrice) stickyPrice.textContent = price;
      if (mainPrice) mainPrice.textContent = price;

      variantOptions.forEach(function (o) {
        if (o.dataset.variantId === variantId) {
          variantOptions.forEach(function (x) { x.classList.remove('active'); });
          o.classList.add('active');
          updateComparePrice(section, o);
        }
      });
    });
  }

  function initMobileStickyATC(section) {
    const sectionId = section.getAttribute('data-section-id');
    const mobileStickyBar = document.getElementById('mobile-sticky-atc-' + sectionId);
    const mobileAtcButton = document.getElementById('mobile-atc-button-' + sectionId);

    if (!mobileStickyBar || !mobileAtcButton) return;

    const variantButtons = mobileStickyBar.querySelectorAll('.premium-sticky-atc-mobile__variant');
    const mainVariantOptions = section.querySelectorAll('.premium-variant__option');
    const mainPrice = section.querySelector('.premium-price__current');

    let selectedVariantId = null;
    const activeVariant = mobileStickyBar.querySelector('.premium-sticky-atc-mobile__variant.active');
    if (activeVariant) selectedVariantId = activeVariant.getAttribute('data-variant-id');

    window.addEventListener('scroll', function () {
      mobileStickyBar.classList.toggle('visible', window.pageYOffset > 300);
    });

    variantButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (this.disabled) return;
        variantButtons.forEach(function (b) { b.classList.remove('active'); });
        this.classList.add('active');
        selectedVariantId = this.getAttribute('data-variant-id');
        mobileAtcButton.disabled = false;

        mainVariantOptions.forEach(function (o) {
          if (o.getAttribute('data-variant-id') === selectedVariantId) {
            mainVariantOptions.forEach(function (x) { x.classList.remove('active'); });
            o.classList.add('active');
            const price = o.getAttribute('data-variant-price');
            if (mainPrice && price) mainPrice.textContent = price;
            updateComparePrice(section, o);
          }
        });
      });
    });

    mainVariantOptions.forEach(function (o) {
      o.addEventListener('click', function () {
        const vid = this.getAttribute('data-variant-id');
        variantButtons.forEach(function (b) {
          b.classList.toggle('active', b.getAttribute('data-variant-id') === vid);
        });
        selectedVariantId = vid;
      });
    });

    function showMobileQty(variantId, qty) {
      let qtyEl = mobileStickyBar.querySelector('.mobile-quantity-selector');
      if (qtyEl) {
        const inp = qtyEl.querySelector('.mobile-quantity__input');
        if (inp) inp.value = qty;
        return;
      }

      mobileAtcButton.style.display = 'none';
      qtyEl = document.createElement('div');
      qtyEl.className = 'mobile-quantity-selector';
      qtyEl.innerHTML = `
        <button class="mobile-quantity__button mobile-quantity__minus" type="button" aria-label="Decrease quantity">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
        </button>
        <input class="mobile-quantity__input" type="number" min="0" value="${qty}" aria-label="Quantity">
        <button class="mobile-quantity__button mobile-quantity__plus" type="button" aria-label="Increase quantity">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
        </button>
      `;
      mobileAtcButton.insertAdjacentElement('afterend', qtyEl);

      const minus = qtyEl.querySelector('.mobile-quantity__minus');
      const plus = qtyEl.querySelector('.mobile-quantity__plus');
      const input = qtyEl.querySelector('.mobile-quantity__input');

      async function updateMobileQty(newQty) {
        if (newQty < 0) newQty = 0;
        try {
          const res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: { [variantId]: newQty } })
          });
          const cart = await res.json();
          input.value = newQty;
          if (window.CartState) { window.CartState.cache = cart; window.CartState.notify(cart); }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          const bubble = document.querySelector('.header__icon--cart .cart-count-bubble');
          if (bubble) bubble.textContent = cart.item_count;
          if (newQty <= 0) {
            qtyEl.remove();
            mobileAtcButton.style.display = 'flex';
            mobileAtcButton.disabled = false;
            mobileAtcButton.innerHTML = '<span>Add to Cart</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
          }
        } catch (e) { console.error(e); }
      }

      minus.addEventListener('click', function () { updateMobileQty(parseInt(input.value) - 1); });
      plus.addEventListener('click', function () { updateMobileQty(parseInt(input.value) + 1); });
      input.addEventListener('change', function () { updateMobileQty(parseInt(input.value) || 0); });
    }

    mobileAtcButton.addEventListener('click', async function () {
      if (!selectedVariantId) { alert('Please select a variant'); return; }
      this.disabled = true;
      this.innerHTML = '<span>Adding...</span>';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: selectedVariantId, quantity: 1 })
        });
        const item = await res.json();
        showMobileQty(item.variant_id, item.quantity);

        if (window.CartState) {
          const cart = await window.CartState.update(true);
          const bubble = document.querySelector('.header__icon--cart .cart-count-bubble');
          if (bubble) bubble.textContent = cart.item_count;
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: item } }));
      } catch (err) {
        console.error(err);
        mobileAtcButton.innerHTML = '<span>Error - Try Again</span>';
        mobileAtcButton.disabled = false;
        setTimeout(function () {
          mobileAtcButton.innerHTML = '<span>Add to Cart</span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>';
        }, 2000);
      }
    });

    if (selectedVariantId) {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        const item = cart.items.find(function (i) { return i.variant_id == selectedVariantId; });
        if (item) showMobileQty(item.variant_id, item.quantity);
      }).catch(function (e) { console.error(e); });
    }
  }

  // Add sticky bar slide animation
  const style = document.createElement('style');
  style.textContent = '.premium-sticky-atc { transform: translateY(100%); transition: transform 0.3s ease; }';
  document.head.appendChild(style);

  function init() {
    document.querySelectorAll('.premium-product-section').forEach(function (section) {
      initCarousel(section);
      initLightbox(section);
      initVariants(section);
      initInlineATC(section);
      initShare(section);
      initDeliveryChecker(section);
      initStickyATC(section);
      initStickyVariantSelect(section);
      initMobileStickyATC(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
